import { render, staticRenderFns } from "./SignUpStepDocument.vue?vue&type=template&id=15ae3730&scoped=true"
import script from "./SignUpStepDocument.vue?vue&type=script&lang=js"
export * from "./SignUpStepDocument.vue?vue&type=script&lang=js"
import style0 from "./SignUpStepDocument.vue?vue&type=style&index=0&id=15ae3730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae3730",
  null
  
)

export default component.exports